import { render, staticRenderFns } from "./SetupInstructions.vue?vue&type=template&id=bb3b8818"
import script from "./SetupInstructions.vue?vue&type=script&lang=js"
export * from "./SetupInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports